import React, {Component} from 'react';
import classnames from 'classnames';

import './ImageEditor.scss';

export default class ImageEditor extends Component {

  state = {
    selectedImage: this.props.value
  }

  componentDidMount() {
    document.addEventListener("click", this.props.viewMode);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.props.viewMode);
  }

  updateUrl = (imageUrl) => {
    this.setState({selectedImage: imageUrl});
    this.refs.url.value = imageUrl;
    this.submitField();
  }

  submitField = (e) => {
    if (e) {
      e.preventDefault();
    }
    const field = this.refs.url;
    this.props.onImageChange(field.name, field.value);
    this.props.viewMode();
  }

  render() {
    const {value, formKey, editMode, images} = this.props;
    let pickerImages = images.map((image, i)=>{
      const imageUrl = window.location.origin + image;
      const pickerClasses = classnames([
        'image-picker-img-container',
        {
          'active': imageUrl === this.state.selectedImage
        }
      ]);
      return(
        <div
          key={i}
          className={pickerClasses}
          style={{backgroundImage: "url(" + imageUrl + ")" }}
          onClick={this.updateUrl.bind(null, imageUrl)}
        />
      );
    });
    return (
      <div className="image-editor" onClick={editMode}>
          <form onSubmit={this.submitField}>
            <div className="image-picker-label">Select Image</div>
            <div className="image-piker-container">
              <div className="image-picker-imgs-container">
                {pickerImages}
              </div>
            </div>
            <small className="text-divider-left">or</small>
            <div className="image-editor-label">Paste Image URL</div>
            <div className="input-group">
              <input
                className="form-control"
                autoFocus={true}
                name={formKey}
                type="url"
                defaultValue={value}
                ref="url"
                required
              />
              <span className="input-group-btn">
                <button
                  className="btn btn-secondary image-editor-button"
                  type="submit">
                  <i className="fa fa-save"/>
                </button>
              </span>
            </div>
          </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/imageField/ImageEditor.jsx